import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { GlobalService } from '../_common/global';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private _global: GlobalService, private api: ApiService) { }
  checklogin(obj: any) {
    return this.api.getCall(environment.MOJO_URL + 'mojo/checklogin/0');
  }
  usertrackingdata(obj: any = {}) {
    return this.api.call(environment.FRAPI_URL + 'stocks/usertrackingdata', obj);
  }
  getData(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getData', obj);
  }
  getModelPortfolioChanges(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getModelPortfolioChanges', obj);
  }
  getActionableInsight(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getActionableInsight', obj);
  }
  getModelPortfolioAlerts(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getModelPortfolioAlerts', obj);
  }
  setHeader(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/setHeader', obj);
  }
  getPrice(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getPrice', obj);
  } 
  getUserData(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getUserData', obj);
  }
  modelportfolio_holdings(obj: any = {}) {
    return this.api.call(environment.MOJO_URL + 'mojo/modelportfolio_holdings', obj);
  }
  resultCornerNew(obj: any = {}) {
    return this.api.getCall(environment.FRAPI_URL + 'screener_Resultcornerfinancialtrend/resultCornerNew?page=2&from=mt');
  }
  mSetaccountid(obj: any = {}) {
    return this.api.call(environment.MOJO_URL + 'mojo/modelportfolio_setaccountid', obj);
  }
  getEvents(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getEvents', obj);
  }
  getSectors(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getSectors', obj);
  }
  getMmarketGraphs(obj: any = {}) {
    return this.api.call(environment.FRAPI_URL + 'newsalert/getportmktgraph', obj);
    //return this.api.call(environment.API_URL + 'mojo_times/getMarketGraphs', obj);
  }
  mojooneGetData(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/mojoOne/getData', obj);
  }
  getPortfolioChanges(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getPortfolioChanges', obj);
  }
  getNews(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getNews', obj);
  }
  getNewsDetails(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getNewsDetails', obj);
  }
  getWebinars(obj: any = {}) {
    return this.api.call(environment.API_URL + 'mojo_times/getWebinars', obj);
  }
  
  getPortfolioData(obj: any = {}) {
    return this.api.call(environment.API_URL  + 'mojo_times/getPortfolioData', obj);
  }
  lastVisitedSearch(domain: any, userid: any) {
    return this.api.getCall(environment.MOJO_URL + 'common_services/searchScripsRecent?domain=' + domain + '&u=' + btoa(userid));
  }
  scriptSearch(str='', domain = '', userid: any) {
    return this.api.getCall(environment.MOJO_URL + 'common_services/searchScrips?section=stock&domain=' + domain +'&SearchPhrase=' + encodeURIComponent(str) + '&u=' + btoa(userid));
  }
  getUserLoginHash(url = '', val: any, domain:any='') {
    let domainUrl = '';
    if (domain == 'infinity') {
      domainUrl = environment.INFINITY_FRAPI_URL;
    } else if (domain == 'trading80') {
      domainUrl = environment.TRA80_URL;
    } else {
      domainUrl = environment.FRAPI_URL;
    }
    return this.api.call(domainUrl + url, val);
  }

  // CMS Banner API methods
  getBanner(placementId: string, bucketId: string = 'new_user_1_day', userId: string = '0', viewport: string = 'desktop') {
    return this.api.getCall(
      `https://marketsmojoapi.motilaloswal.com/api/banners/public?placement_id=${placementId}&bucket_id=${encodeURIComponent(bucketId)}&user_id=${encodeURIComponent(userId)}&viewport=${viewport}`
    );
  }

  trackBannerImpression(payload: any) {
    return this.api.call('https://marketsmojoapi.motilaloswal.com/api/banners/track-impression', payload);
  }

  trackBannerClick(payload: any) {
    return this.api.call('https://marketsmojoapi.motilaloswal.com/api/banners/track-click', payload);
  }

}
